import React from "react"
import { CadastroPromocaoFidelidadeContextProvider } from "./context/CadastroPromocaoFidelidadeContextProvider"
import { CadastroPromocaoFidelidade } from "./CadastroPromocaoFidelidade"

export function Index() {
    return (
        <CadastroPromocaoFidelidadeContextProvider>
            <CadastroPromocaoFidelidade />
        </CadastroPromocaoFidelidadeContextProvider>
    )
}
